import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';

function CopyButton({ text }) {
  const [copied, setCopied] = useState(false);
  return (
    <button
      className="icon-btn"
      onClick={async () => {
        await navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      }}
      title="Copy"
    >
      {copied ? <Check size={14} /> : <Copy size={14} />}
    </button>
  );
}

export function DeployPanel({ terminal, onDeploy, onDisable, deploying }) {
  const [tab, setTab] = useState('curl');
  const deployed = terminal.status === 'deployed';

  return (
    <div className="panel-section deploy-panel">
      <div className="deploy-actions">
        {!deployed ? (
          <button className="btn btn-primary" onClick={onDeploy} disabled={deploying}>
            {deploying ? 'Deploying...' : 'Save & deploy'}
          </button>
        ) : (
          <>
            <button className="btn btn-primary" onClick={onDeploy} disabled={deploying}>
              {deploying ? 'Redeploying...' : 'Redeploy'}
            </button>
            <button className="btn btn-ghost" onClick={onDisable}>
              Disable
            </button>
          </>
        )}
      </div>

      {deployed && (
        <>
          <div className="url-row">
            <code>{terminal.url}</code>
            <CopyButton text={terminal.url} />
          </div>

          <div className="tabs">
            {['curl', 'node', 'python'].map((t) => (
              <button key={t} className={`tab ${tab === t ? 'tab-active' : ''}`} onClick={() => setTab(t)}>
                {t}
              </button>
            ))}
          </div>
          <div className="code-snippet">
            <CopyButton text={terminal.snippets?.[tab] || ''} />
            <pre>{terminal.snippets?.[tab]}</pre>
          </div>
        </>
      )}
    </div>
  );
}
